<template>
	<div :class="colClass">
		<div :class="loggedInUser.role === 'vivu' || loggedInUser.role === 'partner_admin' ? 'panel panel-default border-panel card-view panel-refresh fixed-chart' : `panel panel-default border-panel card-view panel-refresh`" :style="chartStyle" ref="chart">
			<div>
        <div v-if="needOptions" class="dropdown">
          <div style="text-align: center;"><span class="overall-title">{{title}}</span></div>
        </div>
        <div v-if="chartTitle" style="text-align: center;"><span class="overall-title">{{chartTitle}}</span></div>
      	<apexchart type="line" :options="options" :series="series" :height="chartHeight ? chartHeight : options.height"></apexchart>
    	</div>
		</div>
	</div>
</template>
<script>
import ApexCharts from 'apexcharts'
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ActivityChart",
  components: {
		ApexCharts
  },
  props: {
    listOptions: {
      type: Array,
      required: false
    },
		options: {
      type: Object,
      required: true
    },
		series: {
      type: Array,
      required: true
    },
    chartStyle: {
			type: String,
			required: false
    },
    colClasses: {
			type: String,
			required: false
    },
    needOptions: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
          required: false,
    },
    chartTitle: {
      type: String,
          required: false,
    },
    chartHeight: {
      type: String,
          required: false,
    },
	},
  data() {
    return {
      showDropDown: false,
      title: this.$t('app.dashboard.overall'),
		};
  },
  computed: {
    ...mapGetters({
      loggedInUser: "loggedInUser",
    }),
    colClass() {
      if (this.colClasses) {
        return this.colClasses
      }
      if(this.loggedInUser.role === 'admin') {
        return 'col-sm-6 col-md-6 col-xs-6'
      }

      return 'col-sm-12 col-md-12 col-xs-12'
    }
  },
  created() {
    document.addEventListener("click", this.documentClick);
    // window.addEventListener('resize', this.getChartHeight);
  },
  mounted() {
    // this.getChartHeight();
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
    // window.removeEventListener('resize', this.getChartHeight);
  },
  methods: {
    ...mapActions({
    }),
    // getChartHeight() {
    //   if(this.$refs.chart) {
    //     this.$emit('getClientHeight',this.$refs.chart.clientHeight);
    //   }
    // },
    documentClick(e) {
      let apexMenu = document.getElementsByClassName('apexcharts-menu')
      let el = this.$refs["dropdownMenu"];
      let elDefault = this.$refs["dropdownMenuDefault"];
      let elSelect = this.$refs["dropdownMenuSelect"];
      let target = e.target;
      if (el && el !== target && elDefault !== target && elSelect !== target && !el.contains(target)) {
        this.showDropDown = false;
      }
    },
    selectPartner(id,name) {
      this.$emit('selectPartner',id);
      this.showDropDown = false;
      this.title = name
    },
    selectDefault() {
      this.$emit('selectDefault')
      this.showDropDown = false;
      this.title = this.$t('app.dashboard.overall')
    }
	}
};
</script>

<style lang="scss" scoped>
.overall-title {
  font-size: 14px;
  font-weight: 700;
}

.col-xsl-6,.col-md-6,.col-xs-6 {
  @media (max-width: 1754) {
    width: 100% !important;
  }
}

.fixed-chart {
  height: 580px;
}
.menu {
    position: absolute;
    padding: 5px;
    list-style: none;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.175);
    z-index: 1;
    max-height: 280px;
    overflow-y: auto;

    li {
      padding: 10px;
      border-bottom: 1px solid #eee;
      cursor: pointer;

      &:hover {
        background-color:rgba(33, 33, 33, 0.05);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/modules/dashboard/ActivityChart.vue